import React from 'react';
import { ButtonStyles } from './Button.styles';
const Button = ({ addon, addonPosition, branding = 'primary', className, disabled, size, title, type = 'button', onClick, }) => {
    return (React.createElement(ButtonStyles.Button, { className: className, branding: branding, disabled: disabled, size: size, iconPosition: addonPosition, type: type, onClick: onClick },
        addon && addonPosition === 'left' && (React.createElement(ButtonStyles.Icon, { position: addonPosition }, addon)),
        React.createElement(ButtonStyles.Text, null, title),
        addon && addonPosition === 'right' && (React.createElement(ButtonStyles.Icon, { position: addonPosition }, addon))));
};
const LinkButton = ({ addon, addonPosition, branding = 'primary', className, href, size, target = '_self', title, }) => {
    return (React.createElement(ButtonStyles.Button, { className: className, as: "a", branding: branding, href: href, size: size, target: target },
        addon && addonPosition === 'left' && (React.createElement(ButtonStyles.Icon, { position: addonPosition }, addon)),
        React.createElement(ButtonStyles.Text, null, title),
        addon && addonPosition === 'right' && (React.createElement(ButtonStyles.Icon, { position: addonPosition }, addon))));
};
export { Button as default, LinkButton };
